export default __webpack_public_path__ + "static/media/AAPG-Pivoting-10.ca20372f.jpg";